import React, {useState} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import {useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {UberEatsImage} from 'components/UberEatsImage/styles';
import {RedBannerUnderlineText, RedBannerWrapper} from './styles';
import {IconUnPublish} from '../../assets/IconUnPublish';
import Body3 from '../typography/Body3';
import Modal from '../Modals/Modal';
import DialogTitle from '../DialogTitle/styles';
import AnimateLocationDelivery from '../../assets/animate-delivery-red.gif';
import AnimateLocationPickup from '../../assets/animate-pizza-red.gif';
import DialogActions from '../DialogActions/styles';
import DialogAction from '../DialogAction/styles';
import {ButtonOutline, ButtonPrimary} from '../buttons';
import {
  PUBLISH_LOCATION,
  UNPAUSE_LOCATION
} from '../../store/locationSettings/action';
import {
  SHOW_PUBLISH_PROGRESSBAR,
  SHOW_UNPUBLISH_BANNER,
  STOP_GET_PUBLISH_STATUS_JOB
} from '../../store/global/globalNotifications/action';
import {buildUnpauseLocationBody} from '../../helpers/functionUtils/storeSettings';
import {useBannerSlot} from '../BannerStack/BannerStackContext';
import BANNER_STACK_PRIORITY from '../BannerStack/priorities';

const RedBannerDisableStore = ({ClosedManuallyUntilTime}) => {
  const {pathname} = useLocation();
  const stackIndex = useBannerSlot(
    'storeDisabled',
    BANNER_STACK_PRIORITY.storeDisabled
  );

  const entityName = 'Store';
  const getServiceDisabledHint = (timestamp) => {
    const calcTime =
      typeof timestamp === 'object'
        ? Number(Date.parse(timestamp)) / 1000
        : timestamp;
    let text;
    if (calcTime) {
      text = moment(calcTime).utc().format('MM/DD/YYYY HH:mm');
    }
    return text;
  };

  const [isOpenModal, setIsOpenModal] = useState(false);

  const onClose = () => {
    setIsOpenModal(false);
  };
  const dispatch = useDispatch();

  const publishLocation = () => {
    dispatch(
      PUBLISH_LOCATION({
        preCallback: () => {
          dispatch(SHOW_UNPUBLISH_BANNER({showBanner: false, types: []}));
          dispatch(SHOW_PUBLISH_PROGRESSBAR(true));
        },
        postCallBack: () => {},
        errorCallback: () => {
          dispatch(STOP_GET_PUBLISH_STATUS_JOB());
          dispatch(SHOW_PUBLISH_PROGRESSBAR(false));
        }
      })
    );
  };

  const onEnable = () => {
    const storeObj = {
      ClosedManually: false,
      ClosedManuallyTime: null,
      'notSyncedData.ClosedManually': false,
      ClosedManuallyReason: null,
      StoreDisableOption: null,
      ClosedManuallyUntilTime: null
    };
    onClose();
    dispatch(
      UNPAUSE_LOCATION({
        payload: buildUnpauseLocationBody({openRestaurant: true}),
        optimisticPayload: storeObj,
        successCallback: () => {
          publishLocation();
        },
        errorCallback: () => {
          dispatch(STOP_GET_PUBLISH_STATUS_JOB());
          dispatch(SHOW_PUBLISH_PROGRESSBAR(false));
        }
      })
    );
  };

  return (
    <>
      <RedBannerWrapper style={{'--banner-stack-index': stackIndex}}>
        <IconUnPublish />
        <Body3 className='textRedBanner White'>
          The store is disabled until{' '}
          {getServiceDisabledHint(ClosedManuallyUntilTime)}
          {pathname !== '/store-settings' && (
            <RedBannerUnderlineText onClick={() => setIsOpenModal(true)}>
              Click to enable
            </RedBannerUnderlineText>
          )}
        </Body3>
      </RedBannerWrapper>
      {isOpenModal && (
        <Modal
          onCloseAction={() => onClose()}
          title={
            <DialogTitle className='marginBottom2l'>
              Enable <span>{entityName}?</span>
            </DialogTitle>
          }
          width='715px'
          body={
            <>
              <UberEatsImage
                src={
                  entityName === 'Delivery'
                    ? AnimateLocationDelivery
                    : AnimateLocationPickup
                }
              />
              <DialogActions>
                <DialogAction className='w50'>
                  <ButtonOutline onClick={() => onClose()}>
                    <span>Keep it Disabled</span>
                  </ButtonOutline>
                </DialogAction>
                <DialogAction className='w50'>
                  <ButtonPrimary onClick={() => onEnable('store')}>
                    <span>Yes, Enable {entityName}</span>
                  </ButtonPrimary>
                </DialogAction>
              </DialogActions>
            </>
          }
        />
      )}
    </>
  );
};

RedBannerDisableStore.propTypes = {
  ClosedManuallyUntilTime: PropTypes.object.isRequired
};

RedBannerDisableStore.defaultProps = {};

export default RedBannerDisableStore;
